const navbarStyles = {
  removeLinkStyle: {
    textDecorationLine: "none",
  },
  parentBox: {
    zIndex: 2400,
    padding: 0,
    background: "transparent", //white gradient
   
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginTop: 50,
  },
  appBar: {
    padding: 0,
    background: "transparent",
    boxShadow: "none",
    zIndex: 2000,
   
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  avatar: {
    marginLeft: 10,
    marginTop: 3,
    marginBottom:10,
    padding: 22,
    boxShadow: "none",
    borderRadius: 0,
    
  },
  divBorder: {
    width: '100%',
    flexDirection: "row",
   display:'flex',
    background: "transparent",
    justifyContent:'center',
    alignItems:'center'
   
  },
  connectHangBar: {
    background: "#ffffff", position: "absolute", top: 62, left: 0, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, padding: 5, display:'none'
  }
};

export default navbarStyles;